<template>
	<div class="ui-feed-card">
		<div class="ui-feed-card-container">
			<div class="ui-feed-card-header" v-if="hasHeader">
				<slot name="header"></slot>
			</div>

			<div class="ui-feed-card-content">
				<slot />
				<div class="ui-feed-card-arrow"></div>
				<div class="ui-feed-card-pointer"></div>
			</div>

			<div class="ui-feed-card-footer" v-if="hasFooter">
				<slot name="footer"></slot>
			</div>
		</div>

		<div class="ui-feed-card-datetime" v-if="hasDatetime">
			<slot name="datetime"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {},

		data() {
			return {}
		},

		computed: {
			hasHeader() {
				return this.$slots.header ? true : false
			},

			hasFooter() {
				return this.$slots.footer ? true : false
			},

			hasDatetime() {
				return this.$slots.datetime ? true : false
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
